module.exports = __webpack_public_path__ + "images/arrow-down6e5310efcce755a69fe4b4329c54c58b.svg";